import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlight',
  standalone: false,
})
export class HightlightPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(text: string, search: string): SafeHtml {
    //Force text to be a string or it will throw error in toLowerCase
    text = String(text);

    if (!text || !search || !text.toLowerCase().includes(search.toLowerCase())) {
      return text;
    }

    const pattern = search
      .replace(/[\-\[\]\/\{\}\(\)\*\+\@\!\_\?\.\\\^\$\|]/g, '\\$&') // eslint-disable-line
      .split(' ')
      .filter((t) => t.length > 0)
      .join('|');

    return this.sanitizer.bypassSecurityTrustHtml(
      text.replace(
        new RegExp(pattern, 'gi'),
        (match) => `<span class='highlightText'>${match}</span>`,
      ),
    );
  }
}
